
// Here be magic.
// https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
export function latLngDistance(lat1, lng1, lat2, lng2) {
    const dLat = deg2rad(lat2 - lat1);
    const dLng = deg2rad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
        * Math.sin(dLng / 2) * Math.sin(dLng / 2)
        ;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const R = 6371; // Radius of the earth in km
    var d = R * c; // Distance in km
    return d;
}

export function deg2rad(deg) {
    return deg * (Math.PI / 180);
}
